import { AtlasContext } from '../types/atlas';

export const normalizeContextMapping = (context?: AtlasContext | null): Record<string, string> => {
  if (!context || typeof context !== 'object') {
    return {};
  }

  const nestedMapping = context._element_id_by_dimension_id;
  if (nestedMapping && typeof nestedMapping === 'object' && !Array.isArray(nestedMapping)) {
    return Object.fromEntries(
      Object.entries(nestedMapping).map(([dimensionId, elementId]) => [dimensionId, String(elementId)])
    );
  }

  return Object.fromEntries(
    Object.entries(context)
      .filter(([key, value]) => !key.startsWith('_') && typeof value !== 'object')
      .map(([key, value]) => [key, String(value)])
  );
};

export const getContextKey = (context?: AtlasContext | null): string =>
  JSON.stringify(normalizeContextMapping(context));

export const formatContextToken = (value: string): string =>
  value.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

export const getContextLabel = (context?: AtlasContext | null): string => {
  const contextMapping = normalizeContextMapping(context);
  const entries = Object.entries(contextMapping);

  if (entries.length === 0) {
    return 'Default';
  }

  return entries
    .map(([dimensionId, elementId]) => `${formatContextToken(dimensionId)}: ${formatContextToken(elementId)}`)
    .join(', ');
};
